var _defs, _path, _line, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClearloopXIcon01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 226.1 226.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#aeb3c4;}.c{fill:none;stroke:#aeb3c4;stroke-miterlimit:10;stroke-width:8px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M113.05,8c57.92,0,105.05,47.13,105.05,105.05s-47.13,105.05-105.05,105.05S8,170.98,8,113.05,55.13,8,113.05,8m0-8C50.61,0,0,50.61,0,113.05s50.61,113.05,113.05,113.05,113.05-50.61,113.05-113.05S175.49,0,113.05,0h0Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 176.18,
    y1: 49.92,
    x2: 49.92,
    y2: 176.18
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 176.18,
    y1: 176.18,
    x2: 49.92,
    y2: 49.92
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearloopXIcon01);
export default __webpack_public_path__ + "static/media/Clearloop_XIcon_01.a0ce16a1d4fe33be4d614c04125e89b6.svg";
export { ForwardRef as ReactComponent };